import { jsx } from 'react/jsx-runtime';
import '../../../../hooks/index.js';
import '../../../Insight/index.js';
import { useTrackEvent } from '../../../../hooks/useTrackEvent.js';
import { useTrackEventInView } from '../../../../hooks/useTrackEventInView.js';
import { Insight } from '../../../Insight/Insight.js';

/**
 * SectionInsight
 *
 * This component is basically "Insight" with some analytics additional logic.
 * It should only be used in the "Section" component that is rendered in the
 * Discovery View.
 *
 * If you wish to use the UI of this component please use the "Insight" component
 */
const SectionInsight = (props) => {
    const { title } = props;
    // Analytics
    const { trackEvent } = useTrackEvent();
    const { ref } = useTrackEventInView('DISCOVER - I - Item', {
        type: 'load',
        target: title,
    });
    return (jsx(Insight, Object.assign({}, props, { imageRef: ref, onItemClick: () => trackEvent('DISCOVER - I - Item', {
            type: 'click',
            target: title,
        }) })));
};

export { SectionInsight as default };
